<template>
  <div class="inject-page-host" style="width:100%;height:100%;min-height:400px;"></div>
</template>

<script>
export default {
  name: 'SolidWaste',
  mounted() {
    const el = this.$el
    this.$nextTick(() => {
      if (window.SW_mount) window.SW_mount(el)
    })
  },
  beforeDestroy() {
    if (window.SW_destroy) window.SW_destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SolidWaste/index.vue